import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import "./detalleblogs.css"
import Header from "../../../components/header"
import Footer from "../../../components/footer"
import Seo from "../../../components/seo"
import Accesibilidad from "../../../components/accesibilidad"

const Procesoblog = props => {
  let id_recortado = props.location.search.slice(4)

  const query = useStaticQuery(graphql`
    query Procesoblog {
      allStrapiBlogs {
        edges {
          node {
            Contenido
            Imagen {
              url
            }
            Palabra_clave
            Titulo
            id
          }
        }
      }
    }
  `)
  const projects = query.allStrapiBlogs.edges
  let url_global = process.env.GATSBY_API_URL
  let image_url =
    "url(" + url_global + "/uploads/" + "valla_03_6e3f99d9a6.jpg" + ")"

  return (
    <>
      <Accesibilidad />
      <Header site="personas" />

      <Seo />

      <div
        className="absolute w-screen ancho_banner_detalleblog altura_banner lg:w-screen altura_banner posicion_lado_banner_ventaja -top-0 bg-cover bg-right"
        title="valla detalle blog"
        style={{
          zIndex: "0",
          backgroundImage: `${image_url}`,
        }}
      ></div>
      <div
        className="detalle_blog_sm mx-auto container text-poppins-bold lg:relative titulo_ventaja_lg"
        style={{
          color: "#256238",
          top: "5rem",
        }}
      >
        DETALLES BLOG
      </div>

      <div
        style={{
          position: "relative",
          marginTop: "15rem",
          paddingLeft: "16rem",
          paddingRight: "16rem",
        }}
        className="container_dos mitexto ancho_contenido_blog_sm mx-auto w-full justify-items-center px-2 pt-4 pb-12 text-gray-800 espacios_lados_blog"
      >
        <div className="grid grid-cols-1 divide-y-2 divide-gray-200 md:divide-y-2">
          <div className="content py-12 text-justify text-poppins-regular color-texto-parrafo">
            {projects.map(({ node: project }) => {
              if (project.id === id_recortado) {
                return (
                  <div className="mitexto">
                    {!localStorage.getItem("contraste_accesibilidad") && (
                      <p
                        className="mitexto_color title text-poppins-bold green-primary color-texto-parrafo"
                        style={{ position: "relative text-left" }}
                      >
                        {project.Titulo}
                      </p>
                    )}

                    {localStorage.getItem("contraste_accesibilidad") && (
                      <p
                        className="title mitexto_color text-poppins-bold green-primary"
                        style={{ position: "relative text-left" }}
                      >
                        {project.Titulo}
                      </p>
                    )}

                    <br></br>
                    {!localStorage.getItem("contraste_accesibilidad") && (
                      <div
                        className="mitexto_color color-texto-parrafo"
                        style={{
                          position: "relative",
                          marginBottom: "3rem",
                          gridArea: "1/1",
                          overflow: "hidden",
                        }}
                        layout="fullWidth"
                        dangerouslySetInnerHTML={{ __html: project.Contenido }}
                      />
                    )}

                    <div
                      className="mitexto_color"
                      style={{
                        position: "relative",
                        marginBottom: "3rem",
                        gridArea: "1/1",
                        overflow: "hidden",
                      }}
                      layout="fullWidth"
                      dangerouslySetInnerHTML={{ __html: project.Contenido }}
                    />
                  </div>
                )
              }
            })}
          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}

Procesoblog.propTypes = {
  siteTitle: PropTypes.string,
}

Procesoblog.defaultProps = {
  siteTitle: ``,
}

export default Procesoblog
